import { type MaterialInfo, useApiTradeV1DemandSignalsMaterialsRetrieve } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export const MaterialDemandAutocomplete = (props: Omit<AutocompleteFieldProps<MaterialInfo>, 'options'>) => {
  const { data, isLoading } = useApiTradeV1DemandSignalsMaterialsRetrieve();

  return (
    <AutocompleteField<MaterialInfo>
      data-testid="material-autocomplete"
      getOptionLabel={(item) => item.title}
      valueField="id"
      {...props}
      options={data?.results.toSorted((a, b) => a.title.localeCompare(b.title)) ?? []}
      loading={isLoading}
    />
  );
};
